import CityPage from "../CityPage";

export default function BurrRidge() {
  return <CityPage slug="burr-ridge" />;
}
